var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThreeEllipseWhiteMobile = function SvgThreeEllipseWhiteMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.93,
    height: 27.475
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "three-ellipse-white-mobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21273",
    fill: "#fff",
    d: "M0 0h18.93v27.475H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Logo Vector",
    clipPath: "url(#three-ellipse-white-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108538",
    d: "M0 13.656A13.753 13.753 0 0 1 13.737 0h1.005v2.183h-1.005A11.568 11.568 0 0 0 2.183 13.656Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108539",
    d: "M4.188 27.474v-2.183h1a11.568 11.568 0 0 0 11.55-11.473h2.183A13.752 13.752 0 0 1 5.184 27.474Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108540",
    d: "M4.188 23.287v-2.183h1a7.376 7.376 0 0 0 7.373-7.286h2.183a9.561 9.561 0 0 1-9.556 9.469Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108541",
    d: "M4.188 13.657a9.562 9.562 0 0 1 9.55-9.469h1.005v2.183h-1.005a7.376 7.376 0 0 0-7.367 7.286Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108542",
    d: "M4.188 19.101v-2.185h1a3.182 3.182 0 0 0 3.184-3.1v-.081a5.368 5.368 0 0 1 5.366-5.36h1.005v2.183h-1.005a3.184 3.184 0 0 0-3.178 3.1v.081a5.37 5.37 0 0 1-5.373 5.364Z"
  }))));
};
export default SvgThreeEllipseWhiteMobile;